<template>
  <section class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Články - Typy - Nabízené služby - Přidat</strong>
      </div>
      <action-tools :router-options="routerOptions"></action-tools>
    </div>
    <div class="card-body">
      <div class="table-operations">
        <language-tab></language-tab>
      </div>
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item
          label="Název"
          :validate-status="error('ale_name') ? 'error' : ''"
          :help="error('ale_name') || ''"
        >
          <a-input placeholder="Název" v-decorator="['ale_name', {rules: [{max: 60, message: 'Název nemůže být delší než 100 znaků!'}, {required: true, message: 'Název musí být vyplněn!'}]}]"/>
        </a-form-item>

        <a-form-item
          label="Nadpis tučně"
          :validate-status="error('ale_title') ? 'error' : ''"
          :help="error('ale_title') || ''"
        >
          <a-input placeholder="Nadpis tučně" v-decorator="['ale_title', {rules: [{max: 60, message: 'Nadpis tučně nemůže být delší než 60 znaků!'}]}]"/>
        </a-form-item>

        <a-form-item
          label="Nadpis kurzivou"
          :validate-status="error('ale_title_thin') ? 'error' : ''"
          :help="error('ale_title_thin') || ''"
        >
          <a-input placeholder="Nadpis kurzivou" v-decorator="['ale_title_thin', {rules: [{max: 60, message: 'Nadpis kurzivou nemůže být delší než 60 znaků!'}]}]"/>
        </a-form-item>

        <a-form-item
          label="Popisek"
          :validate-status="error('ale_description') ? 'error' : ''"
          :help="error('ale_description') || ''"
        >
          <a-input
            type="textarea"
            :autoSize="{ minRows: 4, maxRows: 10 }"
            placeholder="Popisek"
            v-decorator="['ale_description']"
          />
        </a-form-item>

        <a-form-item>
          <span slot="label">
            Obrázky&nbsp;
            <a-tooltip title="Vyber si obrázek pro jednotlivé položky.">
              <a-icon type="question-circle-o"/>
            </a-tooltip>
          </span>
          <a-row class="pb-5" type="flex" justify="center">
            <a-col :span="8">
              <a-input-search
                placeholder="Hledat..."
                v-model="image.search"
              />
            </a-col>
          </a-row>
          <div v-if="images.data.length > 0">
            <a-row>
              <a-radio-group v-decorator="['existing']" name="image" :class="$style.gallery">
                <a-col v-if="image.selectedOne !== undefined" :xl="4" :md="6" :sm="8" :xs="12">
                  <div :class="{[$style.active]: image.selectedOne.iae_id === form.getFieldValue('existing'), [$style.item]: 1 === 1, [$style.withControls]: 1 === 1}">
                    <img v-if="!image.errors.includes(image.selectedOne.iae_id)" class="img-fluid" :src="$uploadImagePath + image.selectedOne.iae_path + '_6.' + image.selectedOne.iae_format" @error="image.errors.push(image.selectedOne.iae_id)">
                    <a-icon v-else theme="twoTone" twoToneColor="#ccc" type="frown" />
                    <div :class="$style.itemControls">
                      <span :class="$style['item-name']">{{ toImageName(image.selectedOne.iae_name) }}</span>
                      <a-tooltip placement="bottom" title="Číslo položky">
                        <a-input-number
                          v-if="form.getFieldValue('items') !== undefined && form.getFieldValue('items').length > 0"
                          :min="1"
                          :max="form.getFieldValue('items').length"
                          size="small"
                          style="margin-right: 5px;"
                          v-decorator="[`itemNumberOne`, { initialValue: 1 }]"
                        />
                      </a-tooltip>
                      <a-button size="small" icon="edit" @click="changeImage(item, form.getFieldValue('itemNumberOne') || 1)"></a-button>
                      <div>
                        <a-tooltip placement="bottom" title="Pozadí">
                          <a-radio :class="$style['ant-radio-wrapper']" :value="image.selectedOne.iae_id" />
                        </a-tooltip>
                      </div>
                    </div>
                  </div>
                </a-col>
                <a-col :key="'all'+index" v-for="(item, index) in images.data" :xl="4" :md="6" :sm="8" :xs="12">
                  <div :class="{[$style.active]: item.iae_id === form.getFieldValue('existing'), [$style.item]: 1 === 1, [$style.withControls]: 1 === 1}">
                    <img v-if="!image.errors.includes(item.iae_id)" class="img-fluid" :src="$uploadImagePath + item.iae_path + '_6.' + item.iae_format" @error="image.errors.push(item.iae_id)">
                    <a-icon v-else theme="twoTone" twoToneColor="#ccc" type="frown" />
                    <div :class="$style.itemControls">
                      <span :class="$style['item-name']">{{ toImageName(item.iae_name) }}</span>
                      <a-tooltip placement="bottom" title="Číslo položky">
                        <a-input-number
                          v-if="form.getFieldValue('items') !== undefined && form.getFieldValue('items').length > 0"
                          :min="1"
                          :max="form.getFieldValue('items').length"
                          size="small"
                          style="margin-right: 5px;"
                          v-decorator="[`itemNumber[${index}]`, { initialValue: 1 }]"
                        />
                      </a-tooltip>
                      <a-button size="small" icon="edit" @click="changeImage(item, form.getFieldValue('itemNumber['+ index + ']') || 1)"></a-button>
                      <div>
                        <a-tooltip placement="bottom" title="Pozadí">
                          <a-radio :class="$style['ant-radio-wrapper']" :value="item.iae_id"/>
                        </a-tooltip>
                      </div>
                    </div>
                  </div>
                </a-col>
              </a-radio-group>
            </a-row>
            <a-row class="pb-5 pt-5" type="flex" justify="center">
              <a-col :span="8">
                <a-button v-if="imageNextCount > 0" type="primary" class="width-200 d-block m-auto" @click="onNextImagesClick">Načíst další...</a-button>
              </a-col>
            </a-row>
          </div>
          <a-empty v-else>
            <a-spin v-if="!image.loaded" />
          </a-empty>
        </a-form-item>

        <a-form-item
          label="Položky"
          :required="true"
        >
          <a-row
            v-for="(k, index) in form.getFieldValue('items')"
            :key="index">
            <a-col :offset="1" :span="21">
              <a-form-item
                label="Obrázek odrážky"
                :required="true"
              >
                <a-col :xl="4" :md="6" :sm="8" :xs="12">
                  <div v-if="image.selected[index] !== undefined" :class="[$style.item, $style.withControls]">
                    <img v-if="!image.errors.includes(image.selected[index].iae_id)" class="img-fluid" :src="$uploadImagePath + image.selected[index].iae_path + '_6.' + image.selected[index].iae_format" @error="image.errors.push(image.selected[index].iae_id)">
                    <a-icon v-else theme="twoTone" twoToneColor="#ccc" type="frown" />
                    <div :class="$style.itemControls">
                      <span :class="$style['item-name']">{{ toImageName(image.selected[index].iae_name) }}</span>
                    </div>
                  </div>
                  <div v-else>
                    <div :class="[$style.item]">
                      <a-icon theme="twoTone" twoToneColor="#ccc" type="exclamation-circle" />
                    </div>
                    <small class="d-block ml-3">Vyber si obrázek pro tuto položku!</small>
                  </div>
                </a-col>
              </a-form-item>

              <a-form-item
                label="Nadpis"
                :validate-status="error(`title[${index}]`) ? 'error' : ''"
                :help="error(`title[${index}]`) || ''"
              >
                <a-input v-decorator="[`title[${index}]`, { validateTrigger: ['change', 'blur'], rules: [{ required: true, message: 'Nadpis musí být vyplněn!'}]}]"
                         placeholder="Nadpis"
                >
                </a-input>
              </a-form-item>
              <a-form-item
                label="Popisek"
                :validate-status="error(`description[${index}]`) ? 'error' : ''"
                :help="error(`description[${index}]`) || ''"
              >
                <a-input v-decorator="[`description[${index}]`, { validateTrigger: ['change', 'blur'], rules: [{ required: true, message: 'Popisek musí být vyplněn!' }]}]"
                         placeholder="Popisek"
                         :autoSize="{ minRows: 4, maxRows: 10 }"
                         type="textarea"
                />
              </a-form-item>

            </a-col>
            <a-col :span="2">
              <a-icon
                v-if="form.getFieldValue('items').length > 1"
                class="dynamic-delete-button"
                type="minus-circle-o"
                :disabled="form.getFieldValue('items').length === 1"
                @click="() => removeItem(index)"
              />
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <a-button
            class="m-auto d-block"
            type="dashed"
            @click="addItem"
            style="width: 200px;"
          >
            <a-icon type="plus" /> Přidat další
          </a-button>
        </a-form-item>

        <a-form-item label="Zveřejnit?">
          <a-checkbox v-decorator="['ale_is_active', { valuePropName: 'checked', initialValue: true }]"/>
        </a-form-item>

        <a-form-item label="Přidat mezeru pod článek?">
          <a-checkbox v-decorator="['gap', { valuePropName: 'checked', initialValue: true }]"/>
        </a-form-item>

        <div class="form-actions">
          <a-button html-type="submit" type="primary" :disabled="loading || verifyImages() || hasErrors(form.getFieldsError())">Přidat</a-button>
        </div>
      </a-form>
    </div>
  </section>
</template>

<script>
import LanguageTab from '@/components/MyComponents/LanguageTab'
import ActionTools from '@/components/MyComponents/ActionTools'
import { hasErrors } from '../../../../services/forms'

export default {
  components: {
    ActionTools, LanguageTab,
  },
  beforeCreate() {
    this.form = this.$form.createForm(this)
    this.form.getFieldDecorator('items', { initialValue: [], preserve: true })
  },
  data() {
    return {
      hasErrors,
      loading: false,
      id: this.$route.params.id,
      routerOptions: [
        {
          icon: 'bars',
          theme: 'outlined',
          to: '/article/type/cfe',
          title: 'Seznam',
        },
      ],
      item: {
        languages: [],
      },
      image: {
        search: '',
        page: 1,
        loaded: false,
        trigger: false,
        errors: [],
        selected: [],
        selectedOne: undefined,
      },
      formItemLayout: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
      },
      loaded: [],
    }
  },
  computed: {
    images: function () {
      const items = this.$store.getters['image/filteredItems']({ searchText: this.image.search, page: this.image.page })
      if (this.image.selectedOne !== undefined) {
        const filteredData = items.data.filter(x => x.iae_id !== this.image.selectedOne.iae_id)
        return { count: items.count - (items.data.length - filteredData.length), data: filteredData }
      }
      return items
    },
    imageNextCount: function () {
      const imageCount = this.images.count - this.images.data.length
      return imageCount > 6 ? 6 : imageCount
    },
    language: function () {
      return this.$store.getters['language/active']
    },
  },
  methods: {
    verifyImages() {
      let result = false
      this.image.selected.some(value => {
        if (value === undefined) {
          result = true
          return true
        }
      })
      return result
    },
    changeImage(image, destinationIndex) {
      const index = destinationIndex - 1
      this.image.selected[index] = image
      this.form.setFieldsValue({
        items: this.form.getFieldValue('items').concat({ image: undefined, title: undefined, description: undefined }),
      })
      const items = this.form.getFieldValue('items')
      items.pop()
      this.form.setFieldsValue({
        items: items,
      })
    },
    removeItem(index) {
      const items = this.form.getFieldValue('items')
      if (items.length === 1) {
        return
      }
      const titles = this.form.getFieldValue('title')
      const descriptions = this.form.getFieldValue('description')
      items.splice(index, 1)
      titles.splice(index, 1)
      descriptions.splice(index, 1)
      this.image.selected.splice(index, 1)
      this.form.setFieldsValue({
        items: items,
        title: titles,
        description: descriptions,
      })
    },
    toImageName: function (name) {
      const maxLength = 30
      const nameSubstring = name.substring(0, maxLength)
      return nameSubstring.length !== maxLength ? nameSubstring : nameSubstring + '...'
    },
    onNextImagesClick() {
      this.image.page += 1
    },
    addItem() {
      const newIndex = this.form.getFieldValue('items').length
      this.image.selected.push(undefined)
      this.form.getFieldDecorator(`title[${newIndex}]`)
      this.form.getFieldDecorator(`description[${newIndex}]`)
      this.form.setFields({
        items: {
          value: this.form.getFieldValue('items').concat({
            image: undefined,
            title: undefined,
            description: undefined,
          }),
        },
        ['title[' + newIndex + ']']: { value: undefined, errors: ['Nadpis musí být vyplněn!'] },
        ['description[' + newIndex + ']']: { value: undefined, errors: ['Popisek musí být vyplněn!'] },
      })
      this.form.validateFields()
    },
    initData() {
      Promise.all([
        this.$store.dispatch('image/getList'),
      ])
        .catch(() => {})
        .finally(() => {
          this.loaded.push(this.language)
          this.image.loaded = true
        })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.handleChange(this.language)
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('article/post', this.getData())
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    getData() {
      return {
        ate_type: 'CFE',
        languages: this.item.languages.filter(x => x.ale_name !== undefined && x.ale_name.trim().length > 0).map(x => {
          return {
            lge_id: x.lge_id,
            ale_title_thin: x.ale_title_thin !== undefined ? x.ale_title_thin : null,
            ale_content: x.ale_content,
            ale_description: x.ale_description !== undefined ? x.ale_description : null,
            ale_title: x.ale_title !== undefined ? x.ale_title : null,
            ale_name: x.ale_name !== undefined ? x.ale_name : null,
            ale_is_active: x.ale_is_active,
          }
        }),
      }
    },
    handleChange(oldLanguage) {
      const foundObj = { article: false }
      let image
      if (this.form.getFieldValue('existing') !== undefined) {
        image = this.$store.getters['image/getImageById'](this.form.getFieldValue('existing'))
      }
      const newObj = {
        article: {
          lge_id: oldLanguage,
          ale_content: {
            gap: this.form.getFieldValue('gap'),
            image: image,
            items: this.form.getFieldValue('items').map((x, y) => { return { image: this.image.selected[y], title: this.form.getFieldValue('title[' + y + ']'), description: this.form.getFieldValue('description[' + y + ']') } }),
          },
          ale_name: this.form.getFieldValue('ale_name'),
          ale_title_thin: this.form.getFieldValue('ale_title_thin'),
          ale_title: this.form.getFieldValue('ale_title'),
          ale_description: this.form.getFieldValue('ale_description'),
          ale_is_active: this.form.getFieldValue('ale_is_active'),
        },
      }
      this.item.languages.some((value, key) => {
        if (value.lge_id === oldLanguage) {
          this.item.languages[key] = newObj.article
          foundObj.article = true
          return true
        }
      })
      if (!foundObj.article) {
        this.item.languages.push(newObj.article)
      }
    },
    error(fieldName) {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched(fieldName) && getFieldError(fieldName)
    },
  },
  created() {
    this.initData()
    if (this.form.getFieldValue('items').length === 0) {
      this.addItem()
    }
  },
  watch: {
    language(newValue, oldValue) {
      if (oldValue !== null) {
        this.handleChange(oldValue)
      }
      if (newValue !== null) {
        const foundObj = { article: this.item.languages.find(x => x.lge_id === newValue) }
        let newObj
        if (foundObj.article === undefined) {
          newObj = {
            ale_name: undefined,
            ale_is_active: true,
            ale_description: undefined,
            ale_title_thin: undefined,
            ale_title: undefined,
            gap: true,
            existing: undefined,
          }
          if (this.form.getFieldValue('items').length === 0) {
            this.addItem()
          }
          this.image.selected = []
          this.image.selectedOne = undefined
        } else {
          newObj = {
            gap: foundObj.article.ale_content.gap,
            ale_name: foundObj.article.ale_name,
            ale_is_active: foundObj.article.ale_is_active,
            ale_description: foundObj.article.ale_description,
            ale_title_thin: foundObj.article.ale_title_thin,
            ale_title: foundObj.article.ale_title,
            items: foundObj.article.ale_content.items,
            existing: foundObj.article.ale_content.image === undefined ? undefined : foundObj.article.ale_content.image.iae_id,
          }
          this.image.selectedOne = foundObj.article.ale_content.image === undefined ? undefined : foundObj.article.ale_content.image
          this.image.selected = []
          foundObj.article.ale_content.items.forEach((value, key) => {
            this.image.selected.push(value.image)
            this.form.getFieldDecorator(`title[${key}]`)
            this.form.getFieldDecorator(`description[${key}]`)
            this.form.setFields({
              ['title[' + key + ']']: { value: value.title, errors: value.title === undefined || value.title.trim().length === 0 ? ['Nadpis musí být vyplněn!'] : undefined },
              ['description[' + key + ']']: { value: value.description, errors: value.description === undefined || value.description.trim().length === 0 ? ['Popisek musí být vyplněn!'] : undefined },
            })
          })
        }
        this.form.getFieldDecorator('existing')
        this.form.setFieldsValue(newObj)
        this.image.trigger = !this.image.trigger
        this.form.validateFields()
      }
    },
  },
}
</script>

<style lang="scss" module>
  @import "./style.module.scss";
</style>
